module.exports = __webpack_public_path__ + "static/media/2.249a0678.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/rhand/2.png
// module id = 937
// module chunks = 0